import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { FileChipInputProps } from './types';

import FileInput from './index';

type Props = Omit<FileChipInputProps, "onSubmit"> & {
    name: string;
    helperText?: string;
    control?: any;
};

export default function RHFFileInput({ name, helperText, ...other }: Props) {
    let { control } = useFormContext() || {};

    control = control || other.control;

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <div>
                    <FileInput
                        files={field.value}
                        setFiles={field.onChange}
                        onSubmit={(options: any) => {
                            field.onChange(options);
                        }}
                        {...other}
                    />
                    {error ? (
                        <span className='text-sm text-rejectDark pt-[5px]'>{error?.message}</span>
                    ) : (
                        <span>{helperText}</span>
                    )}
                </ div>
            )}
        />
    );
}